import { api } from "@/shared/api";

// W3 视频资产库(动作库/环境床)。列表 url/thumbUrl 是预览签名(24h);
// **选用落 references 用 objectKey**(稳定 ref,渲染派发由 ai 现签)。

export interface VideoMotionAssetDto {
  id: number;
  source: "platform" | "tenant";
  name: string;
  category: string; // talk|hold_product|showcase|walk|turn|sit|stand
  objectKey: string;
  durationSec: number | null;
  shotSizes: string[];
  status: "active" | "disabled";
  url: string | null;
  thumbUrl: string | null;
}

export interface VideoAmbientBedDto {
  id: number;
  name: string;
  sceneKey: string;
  objectKey: string;
  durationSec: number | null;
  loop: boolean;
  status: "active" | "disabled";
  url: string | null;
}

export const MOTION_CATEGORY_LABEL: Record<string, string> = {
  talk: "口播",
  hold_product: "举产品",
  showcase: "展示",
  walk: "走位",
  turn: "转身",
  sit: "坐",
  stand: "站",
};

const BASE = "/video/asset-library";

export const videoAssetService = {
  listMotions: (includeDisabled = false) =>
    api.get<VideoMotionAssetDto[]>(
      `${BASE}/motions${includeDisabled ? "?includeDisabled=true" : ""}`
    ),

  /** 租户动作上传(V1 整段;durationSec 由前端 video 元数据探出,服务端 15.2s 墙同口径拒项)。 */
  uploadMotion: (input: {
    file: File;
    name: string;
    category: string;
    durationSec: number;
    shotSizes?: string;
  }) => {
    const fd = new FormData();
    fd.append("file", input.file);
    fd.append("name", input.name);
    fd.append("category", input.category);
    fd.append("durationSec", String(input.durationSec));
    if (input.shotSizes) fd.append("shotSizes", input.shotSizes);
    return api.post<VideoMotionAssetDto>(`${BASE}/motions`, fd);
  },

  setMotionStatus: (id: number, status: "active" | "disabled") =>
    api.post<VideoMotionAssetDto>(`${BASE}/motions/${id}/status`, { status }),

  listBeds: (includeDisabled = false) =>
    api.get<VideoAmbientBedDto[]>(`${BASE}/beds${includeDisabled ? "?includeDisabled=true" : ""}`),
};
